import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable()
export class TimeSyncService {

  constructor(private httpClient: HttpClient) {
  }

  getClientTimeSyncXcos(): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/time-sync-xcos');
  }

  getTimeSyncDataByXco(xco: string): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/time-sync-data?cross-connect=' + xco);
  }

}
